import { render } from "./CallDetailPage.vue?vue&type=template&id=5307e40c&ts=true"
import script from "./CallDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/CallDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5307e40c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5307e40c', __exports__)) {
    api.reload('5307e40c', __exports__)
  }
  
  module.hot.accept("./CallDetailPage.vue?vue&type=template&id=5307e40c&ts=true", () => {
    api.rerender('5307e40c', render)
  })

}


export default __exports__